import { SagaIterator } from 'redux-saga';
import { put, all, takeLatest } from 'redux-saga/effects';
import { registerServiceWorker } from '@wix/da-shared-react/pkg/redux/pwa/actions';
import { APP_LOADED } from '../actions/app';

function* appLoadedSaga() {
  yield put(registerServiceWorker());
}

export default function* appSaga(): SagaIterator {
  yield all([takeLatest(APP_LOADED, appLoadedSaga)]);
}
